import Footer from "../../layout/footer";
import Header from "../../layout/header-3";
import Link from "next/link";
import Image from "next/image";
import BlogFAQ from "../../element/blogFAQ";
import BlogItem from "../../element/BlogItem";
import {
  NextSeo,
  ArticleJsonLd,
  BreadcrumbJsonLd,
  FAQPageJsonLd,
} from "next-seo";
import HTMLReactParser from "html-react-parser";
import Cta from "../../element/shortcode/cta";

const handleShortcodes = (node) => {
  if (node.type && node.type === "tag") {
    const shortcode = node.name;
    if (shortcode === "cta") {
      return <Cta item={node.attribs} />;
    }
  }
  return node;
};

function Details({ post }) {
  //const description = HTMLReactParser(`<cta title="النص الاساسي" sub_title="العنوان الفرعي" action_button_url="/register" action_button_title="المزيد" />`, {
  const description = HTMLReactParser(post.data.description, {
    replace: handleShortcodes,
  });
  return (
    <>
      <NextSeo
        title={post.data.site_title}
        description={post.data.meta_description}
        canonical={"https://esmart.sa/blog/" + post.data.slug}
      />

      <ArticleJsonLd
        url={"https://esmart.sa/blog/" + post.data.slug}
        title={post.data.site_title}
        images={[post.data.image]}
        datePublished={post.data.created_at}
        dateModified={post.data.updated_at}
        authorName={[
          {
            name: "eSmart",
            url: "https://esmart.sa",
          },
        ]}
        publisherName="eSmart"
        publisherLogo="https://esmart.sa/images/favicon.png"
        description={post.data.meta_description}
        isAccessibleForFree={true}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "الرئيسية",
            item: "https://esmart.sa",
          },
          {
            position: 2,
            name: post.data.site_title,
            item: "https://esmart.sa/blog/" + post.data.slug,
          },
        ]}
      />
      {post.data.faq.length > 0 && (
        <FAQPageJsonLd
          mainEntity={post.data.faq.map((item) => {
            return {
              questionName: item.Question,
              acceptedAnswerText: item.Answer,
            };
          })}
        />
      )}
      <Header />
      <div className="page-content bg-white">
        {/* <!-- Banner  --> */}
        <div
          className="dlab-bnr-inr overlay-gradient-dark"
          style={{ backgroundImage: "url(" + post.data.image + ")" }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1>{post.data.title}</h1>
              {/* <!-- Breadcrumb Row --> 
							
							<nav aria-label="breadcrumb" className="breadcrumb-row">
								<ul className="breadcrumb">
									<li className="breadcrumb-item"><Link legacyBehavior href="/"><a>الرئيسية</a></Link></li>
									<li className="breadcrumb-item active" aria-current="page">{post.data.title}</li>
								</ul>
							</nav>
							{/* <!-- Breadcrumb Row End --> */}
            </div>
          </div>
        </div>
        {/* <!-- Banner End --> */}

        {/* <!-- Blog Large --> */}
        <section className="content-inner bg-img-fix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                {/* <!-- blog start --> */}
                <div className="dlab-blog blog-single style-2">
                  <div className="dlab-media rounded-md shadow">
                    <Image
                      priority
                      width="600"
                      height="250"
                      src={post.data.image}
                      alt={post.data.title}
                    />
                  </div>
                  <div className="dlab-meta m-t30">
                    <ul>
                      <li className="post-category">
                        <i className="fa fa-book m-l10"></i>
                        <Link
                          href={"/blog/?category_id=" + post.data.category_id}
                        >
                          {post.data.category}
                        </Link>
                      </li>
                      <li className="post-author">
                        <i className="fa fa-user m-l10"></i>eSmart Team
                      </li>
                      <li className="created-at">
                        <i className="fa fa-clock-o m-l10"></i>تاريخ الإنشاء{" "}
                        {post.data.created_at}
                      </li>
                      <li className="updated-at">
                        <i className="fa fa-clock-o m-l10"></i>تاريخ التعديل{" "}
                        {post.data.updated_at}
                      </li>
                    </ul>
                  </div>
                  <h4 className="dlab-title">{post.data.title}</h4>
                  <div className="dlab-post-text">{description}</div>
                </div>
                {post.data.faq.length > 0 && (
                  <div className="row extra-blog style-2">
                    <div className="col-lg-12 m-b30">
                      <h2 className="blog-title">اسئلة شائعة</h2>
                      <div className="dlab-separator style-1"></div>
                    </div>
                    <div className="col-lg-12">
                      <BlogFAQ defaultAccordion={post.data.faq} />
                    </div>
                  </div>
                )}
                {post.data.related.length > 0 && (
                  <div className="row extra-blog style-2">
                    <div className="col-lg-12 m-b30">
                      <h2 className="blog-title">مقالات ذات علاقة</h2>
                      <div className="dlab-separator style-1"></div>
                    </div>
                    <div className="row">
                      {post.data.related.map((item) => (
                        <BlogItem key={item.id} post={item} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export async function getStaticProps(context) {
  const res = await fetch(
    "https://backend.esmart.sa/api/articles/" + context.params.slug,
    { headers: { "User-Agent": "eSmartWebSite" } }
  );
  if (!res.ok) {
    return {
      redirect: {
        destination: `/500`,
        permanent: false,
      },
    };
  }
  const post = await res.json();

  if (!post.data) {
    return {
      redirect: {
        destination: `/`,
        permanent: false,
      },
    };
  }

  return {
    props: {
      post,
    },
  };
}
export async function getStaticPaths() {
  const res = await fetch(
    "https://backend.esmart.sa/api/articles-sitemap.xml",
    { headers: { "User-Agent": "eSmartWebSite" } }
  );
  const posts = await res.json();

  const paths = posts.data.map((post) => ({
    params: { slug: post.slug },
  }));

  return { paths, fallback: "blocking" };
}

export default Details;
